export default {
      id: "ic-soc-linkedin-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-linkedin-usage",
      toString: function () {
        return this.url;
      }
    }